module.exports = __webpack_public_path__ + "img/电脑.deaf8624.png";